import { render, staticRenderFns } from "./CustomerEditHistory.vue?vue&type=template&id=132ba3c1&scoped=true"
import script from "./CustomerEditHistory.vue?vue&type=script&lang=js"
export * from "./CustomerEditHistory.vue?vue&type=script&lang=js"
import style0 from "./CustomerEditHistory.vue?vue&type=style&index=0&id=132ba3c1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132ba3c1",
  null
  
)

export default component.exports